'use strict';

var constants = require('./constants-0cf35288.js');

var isConsumerTheme = function (theme) { return theme.variant === constants.THEME_VARIANT.CONSUMER; };
var isAdminTheme = function (theme) { return theme.variant === constants.THEME_VARIANT.ADMIN; };

exports.isAdminTheme = isAdminTheme;
exports.isConsumerTheme = isConsumerTheme;
